import { requirePermission } from "@lib/permissions/guards";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ClipboardList } from "lucide-react";

export const Route = createFileRoute("/_app/stock/inventaires")({
  staticData: {
    title: "Inventaires",
    icon: ClipboardList,
    tab_icon: ClipboardList,
    permission: "stock.inventaires.view",
    module: "stock",
    section: "Stock",
    order: 49,
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  loader: requirePermission("stock.inventaires.view"),
  component: () => <Outlet />,
});
